
import Hero from './components/Hero';
import Services from './components/Services';
import DeviceModels from './components/DeviceModels';
import About from './components/About';
import Gallery from './components/Gallery';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Services />
      <DeviceModels />
      <About />
      <Gallery />
      <Testimonials />
      <FAQ />
      <Contact />
      <CTASection />
      <Footer />
    </div>
  );
}
